import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  actionTo?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  actionLabel,
  actionTo,
}: SectionHeadingProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3 mb-6 md:mb-8">
      <div>
        {eyebrow && (
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100 text-accent-900 text-xs font-medium font-label mb-3">
            <i className="ri-flashlight-line"></i>
            {eyebrow}
          </span>
        )}
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
          {title}
        </h2>
        {description && (
          <p className="mt-2 text-sm md:text-base text-foreground-500 max-w-2xl leading-relaxed">
            {description}
          </p>
        )}
      </div>
      {actionLabel && actionTo && (
        <Link
          to={actionTo}
          className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 whitespace-nowrap transition-colors cursor-pointer shrink-0"
        >
          {actionLabel}
          <i className="ri-arrow-right-line"></i>
        </Link>
      )}
    </div>
  );
}